import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme } from '../../../../styles';

const useStyles = createUseStyles(
  ({ spacing }: ITheme) => ({
    widgetContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: 'inherit',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 8,
    },
    imgContainer: {
      height: 84,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    image: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },

    heading: {
      fontSize: 20,
      fontWeight: FontWeight.SemiBold,
      lineHeight: '28px',
      textAlign: 'center',
      color: 'var(--x-accent-2-1)',
      margin: '16px 0',
    },

    stickyUpload: ({ errorMessage }: { errorMessage: string }) => ({
      display: 'flex',
      alignContent: 'center',
      width: '100%',
      maxHeight: 80,
      padding: spacing.xLarge,
      ...(errorMessage && {
        border: 'none',
      }),
    }),

    button: {
      padding: 8,
      width: '100%',
      fontSize: '14px',
      lineHeight: '24px',
    },
  }),
  {
    name: 'upload-widget',
  },
);

export default useStyles;
